module.exports = __webpack_public_path__ + "img/flag-3.7b01cc19.svg";